import { LeadService } from "../../leads";
import { sendLeadIntegrationService } from "./send-lead-integration-service";

export async function saveExternalLead(dataLead, context) {
  const ls = new LeadService(context?.req, context?.res);
  try {
    const currentLead = context.email
      ? await ls.findByEmail({ email: context.email })
      : await ls.find();
    if (!currentLead?.attributes) {
      return false;
    }
    const result = await sendLeadIntegrationService(dataLead, currentLead);
    if (!currentLead.attributes.external_id && result.data.external_id) {
      await ls.save({
        external_id: result.data.external_id,
      });
    }
    return result;
  } catch (error) {
    return false;
  }
}
